import React from "react";
import { Box, Tooltip, TableCell } from "@mui/material";
import { RiUserStarLine } from "react-icons/ri";
import { PiUserSwitch } from "react-icons/pi";
import { COLOR_GRAY, COLOR_NEW, COLOR_FREQUENT } from "../ListadoSolicitud.constants";

// Columna "Identificador": dos íconos circulares que indican si el cliente es
// reiterativo histórico y/o frecuente/vigente.
export default function CeldaIdentificador({ data }) {
  return (
    <TableCell align="center">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8
        }}
      >

        {/* CLIENTE VIGENTE */}
        <Tooltip
          title={
            " Reiterativo Histórico"
          }
          placement="top"
        >
          <Box
            component="span"
            sx={{
              cursor: "default",
              width: 34,
              height: 34,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor:
                data.iClienteReiterativo === 1
                  ? COLOR_NEW
                  : "transparent",
              border: data.iClienteReiterativo === 1
                ? `1px solid ${COLOR_NEW}`
                : `1px solid ${COLOR_GRAY}`,
              color:
                data.iClienteReiterativo === 1
                  ? "#ffffff"
                  : COLOR_GRAY,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor:
                  data.iClienteReiterativo === 1
                    ? COLOR_NEW
                    : "rgba(0,0,0,0.04)",
              },
            }}
          >
            <RiUserStarLine
              size={20}
              color={
                data.iClienteReiterativo === 1
                  ? "#ffffff"
                  : COLOR_GRAY
              }
            />
          </Box>
        </Tooltip>

        {/* CLIENTE REITERATIVO */}
        <Tooltip
          title={
            "Frecuente"
          }
          placement="top"
        >
          <Box
            component="span"
            sx={{
              cursor: "default",
              width: 34,
              height: 34,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor:
                data.iClienteVigente === 1
                  ? COLOR_FREQUENT
                  : "transparent",
              border: data.iClienteVigente === 1
                ? `1px solid ${COLOR_FREQUENT}`
                : `1px solid ${COLOR_GRAY}`,
              color:
                data.iClienteVigente === 1
                  ? "#ffffff"
                  : COLOR_GRAY,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor:
                  data.iClienteVigente === 1
                    ? COLOR_FREQUENT
                    : "rgba(0,0,0,0.04)",
              },
            }}
          >
            <PiUserSwitch
              size={20}
              color={
                data.iClienteVigente === 1
                  ? "#ffffff"
                  : COLOR_GRAY
              }
            />
          </Box>
        </Tooltip>
      </div>
    </TableCell>
  );
}
